import { Table } from 'flowbite-react';
import { DATE_FORMAT, DATE_TIME_FORMAT } from "../../consts/common-consts";
import { parseAndFormat } from "../../helpers/utils/date-util";
import Loader from "../form-loader/form-loader";
import NoDataMessage from '../no-data-message';
import RowOptionsMenu from './row-options-menu';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Index({
  headers = [],
  items = [],
  onChangeEnable = () => {
  },
  itemsNotFoundMessage = "Don't have any data",
  itemsNotFoundHelperMessage,
  itemsNotFoundIcon,
  modifiedColumn = true,
  selectedItems = [], // keep these items in main page and table will take care of compare and display
  selectKey = 'id', // provide a unique field to compare the records and selected records
  multiSelect = false, // control to enable checkboxes
  onRowSelect = (_) => { }, // trigger on select
  onSelectAllClick = () => { }, // trigger on select all/ deselect all click
  enableColumn = true,
  dataLoadingState = {
    processing: false,
    success: false,
    failed: false,
    errorMessage: ''
  },
  filterCondition = () => true
}) {
  const loadingMockArray = [1, 1, 1, 1];
  const isSelected = (record) => {
    return (
      selectedItems?.length > 0 &&
      selectKey in record &&
      selectedItems.some((selectedRecord) => selectedRecord[selectKey] === record[selectKey])
    );
  };
  const handleRowSelect = (rec) => {
    if (onRowSelect) {
      onRowSelect(rec);
    } else {
      return false;
    }
  }
  return (
    <>
      {dataLoadingState.processing && <div className="py-6"><Loader text="Loading..." /></div>}

      {dataLoadingState.processing &&
        <div className="pt-8 flex flex-row justify-center items-center">
          <div className="flex-1 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-4">
            {loadingMockArray.map((i) => <>
              <div
                key={i}
                className="border border-gray-300 dark-border shadow rounded-md p-4 max-w-sm w-full mx-auto">
                <div className="animate-pulse flex space-x-4">
                  <div className="flex-1 space-y-6 py-1">
                    <div className="h-2 bg-slate-200 rounded"></div>
                    <div className="space-y-3">
                      <div className="grid grid-cols-3 gap-4">
                        <div
                          className="h-2 bg-slate-200 rounded col-span-2"></div>
                        <div
                          className="h-2 bg-slate-200 rounded col-span-1"></div>
                      </div>
                      <div className="h-2 bg-slate-200 rounded"></div>
                    </div>
                  </div>
                </div>
              </div>
            </>)}
          </div>
        </div>
      }

      {(!dataLoadingState.processing && items.length === 0) &&
        <NoDataMessage
          title={itemsNotFoundMessage}
          message={itemsNotFoundHelperMessage}
          icon={itemsNotFoundIcon}
        />
      }

      {(!dataLoadingState.processing && items.length > 0) &&
        <div className="pt-4">
          <div
            className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
            <Table className="">
              <Table.Head className="border-b border-gray-200">
                {multiSelect && (
                  <Table.HeadCell>
                    <input id="table-head-checkbox" type="checkbox" value="" class="w-4 h-4 cursor-pointer text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 focus:ring-1"
                      onChange={onSelectAllClick}
                      checked={selectedItems?.length === items.length}
                    />
                  </Table.HeadCell>
                )}
                {headers.map(((h, index) =>
                  <Table.HeadCell
                    className="bg-gray-50/80 text-xs font-semibold uppercase tracking-wide text-gray-500"
                    key={`header_${index}`}>
                    {h}
                  </Table.HeadCell>
                ))}
                {modifiedColumn &&
                  <Table.HeadCell className="bg-gray-50/80 text-xs font-semibold uppercase tracking-wide text-gray-500">
                    Updated At
                  </Table.HeadCell>
                }
                <Table.HeadCell className="bg-gray-50/80">
                  <span className="sr-only">
                    Edit
                  </span>
                </Table.HeadCell>
              </Table.Head>
              <Table.Body className="divide-y">
                {items.map((item, index) => {
                  const { record, columnsData, rowClassName } = item;
                  const tds = [];
                  for (const cd of columnsData) {
                    const { data, isEnableField, options, isIdField, isUpdatedField, isDateTimeField } = cd;
                    let tdElement;
                    if (options && options.length > 0) {
                      tdElement =
                        <td className="whitespace-nowrap px-6 py-4 text-right text-sm text-gray-500">
                          <RowOptionsMenu options={options} record={record} />
                        </td>
                    } else if (modifiedColumn && isUpdatedField) {
                      let value;
                      if (isDateTimeField){
                        value = parseAndFormat(data, DATE_TIME_FORMAT)
                      } else {
                        value = parseAndFormat(data, DATE_FORMAT)
                      }
                      tdElement =
                        <Table.Cell
                          className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                          {value}
                        </Table.Cell>
                    } else {
                      tdElement =
                        <Table.Cell className="">
                          {isIdField
                            ? <span className="font-medium text-gray-900">{data}</span>
                            : <span className="text-gray-600">{data}</span>
                          }
                        </Table.Cell>
                    }

                    if (filterCondition(record)) {
                      tds.push(tdElement);
                    }
                  }

                  return (
                    <Table.Row
                      key={`row_${index}`}
                      className={classNames(
                        'border-b border-gray-100 bg-white transition-colors last:border-0 hover:bg-gray-50/70',
                        rowClassName
                      )}>
                      {multiSelect && (
                        <Table.Cell>
                          <input id={`table_row_${index}_checkbox`} type="checkbox" value="" class="w-4 h-4 cursor-pointer text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 focus:ring-1"
                            checked={isSelected(record)}
                            onChange={() => handleRowSelect(record)}
                          />
                        </Table.Cell>
                      )}
                      {tds}
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
          </div>
        </div>
      }
    </>
  )
}